import store from '@/store';
import DashboardLogo from '@/assets/images/dashboard.svg';
import SellProductsLogo from '@/assets/images/stock.svg';
import SuppliersLogo from '@/assets/images/supplier.svg';
import ClientsLogo from '@/assets/images/clients.svg';
import HumanResourcesLogo from '@/assets/images/teams.svg';
import FinanceLogo from '@/assets/images/finance.svg';
import WareHouseLogo from '@/assets/images/warehouses.svg';
import MaterialLogo from '@/assets/images/material.svg';
import Products1Logo from '@/assets/images/products.svg';
import OrdersManagementLogo from '@/assets/images/ordermanagement.svg';
import TakeMeasurementLogo from '@/assets/images/createorder.svg';


const getOrdersPath = () => {
  if (store.getters.getLoggedInUser.role === 'Deliverer') {
    return '/orders-overview/ReadyToDeliver';
  } if (store.getters.getLoggedInUser.role === 'TeamLeader') {
    return '/orders-overview/Assigned';
  }
  return '/orders-overview/all';
};


const menuItems = [
  {
    title: 'Dashboard',
    path: '/',
    icon: DashboardLogo,
    roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'SalesPerson', 'TeamLeader'],
  },
  {
    title: 'CreateOrderGenerally',
    path: null,
    method: 'callNewMethodsOrder',
    icon: TakeMeasurementLogo,
    roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'SalesPerson', 'TeamLeader'],
  },
  {
    title: 'SellProducts',
    path: '/products-stock-sidebar',
    icon: SellProductsLogo,
    roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'SalesPerson', 'TeamLeader'],
  },
  {
    title: 'Orders',
    icon: OrdersManagementLogo,
    roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'SalesPerson', 'TeamLeader', 'ProductionManager'],
    children: [
      { title: 'NewOrders', roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'TeamLeader', 'ProductionManager'], path: '/orders-management' },
      { title: 'MontageOverview', roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'TeamLeader'], path: '/montage-overview' },
      { title: 'ProductionManagement', roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'TeamLeader', 'ProductionManager'], path: '/production-management' },
      { title: 'OrdersOverview', roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'SalesPerson', 'TeamLeader'], path: getOrdersPath() },
      { title: 'OrdersOverviewPartially', roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'SalesPerson', 'TeamLeader'], path: '/orders-overview-partially' },
      { title: 'SellingReport', roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'TeamLeader'], path: '/selling' },
      { title: 'InternalMoving', roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'TeamLeader', 'ProductionManager'], path: '/internal-movements' },
      { title: 'AdminAuthorise', roles: ['Admin', 'CEO'], path: '/admin' },
    ],
  },
  {
    title: 'Products1',
    icon: Products1Logo,
    roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'TeamLeader'],
    children: [
      { title: 'ProductManagement', roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'SalesPerson', 'TeamLeader'], path: '/products' },
      { title: 'ProductReporting', roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'SalesPerson', 'TeamLeader'], path: '/product-reporting' },
      { title: 'Configurations', roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'SalesPerson', 'TeamLeader'], path: '/product-configuration' },
    ],
  },
  {
    title: 'StockinStore',
    icon: SellProductsLogo,
    roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'SalesPerson', 'TeamLeader'],
    children: [
      { title: 'Productionmerch', roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'SalesPerson', 'TeamLeader'], path: '/product-in-stock' },
      { title: 'CartForArticles', roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'SalesPerson', 'TeamLeader'], path: '/products-in-stock' },
      { title: 'ProductsInStock', roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'SalesPerson', 'TeamLeader'], path: '/products-stock' },
    ],
  },
  {
    title: 'Materials',
    icon: MaterialLogo,
    roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'SalesPerson', 'TeamLeader'],
    children: [
      { title: 'InventoryManagement', roles: ['Admin', 'CEO', 'Manager', 'TeamLeader'], path: '/inventory' },
      { title: 'InventoryReporting', roles: ['Admin', 'CEO', 'Manager', 'TeamLeader'], path: '/inventory-reporting' },
      { title: 'InventoryOverview', roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'SalesPerson', 'TeamLeader'], path: '/inventory-overview' },
      { title: 'MaterialColors', roles: ['Admin', 'CEO', 'Manager', 'TeamLeader'], path: '/material-colors' },
      { title: 'CartForMaterials', roles: ['Admin', 'CEO', 'Manager', 'TeamLeader'], path: '/cart' },
      { title: 'BuyDirect', roles: ['Admin', 'CEO', 'Manager', 'TeamLeader'], path: '/buy-direct' },
    ],
  },
  {
    title: 'HumanResources',
    icon: HumanResourcesLogo,
    roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'TeamLeader'],
    children: [
      { title: 'HumanResourcesDashboard', roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'SalesPerson', 'TeamLeader'], path: '/hr-dashboard' },
      { title: 'TeamsManagement', roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'TeamLeader'], path: '/teams' },
      { title: 'EmployeeManagement', roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'TeamLeader'], path: '/users' },
    ],
  },
  {
    title: 'Finance',
    icon: FinanceLogo,
    roles: ['Admin', 'CEO', 'Manager', 'TeamLeader'],
    children: [
      { title: 'FinanceDashboard', roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'SalesPerson', 'TeamLeader'], path: '/finance-dashboard' },
      { title: 'FinancialReport', roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'SalesPerson', 'TeamLeader'], path: '/finance-report' },
      { title: 'Salary', roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'SalesPerson', 'TeamLeader'], path: '/employee-payments' },
      { title: 'Configurations', roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'SalesPerson', 'TeamLeader'], path: '/finance-account' },
    ],
  },
  {
    title: 'WareHouse',
    icon: WareHouseLogo,
    roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'SalesPerson', 'TeamLeader'],
    children: [
      { title: 'Location', roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'SalesPerson', 'TeamLeader'], path: '/location' },
      { title: 'MaterialVariantLocation', roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'SalesPerson', 'TeamLeader'], path: '/material-variant-location' },
      { title: 'Store', roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'SalesPerson', 'TeamLeader'], path: '/filiales' },
    ],
  },
  {
    title: 'Suppliers',
    path: '/suppliers',
    icon: SuppliersLogo,
    roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'TeamLeader'],
  },
  {
    title: 'Clients',
    icon: ClientsLogo,
    roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'SalesPerson', 'TeamLeader'],
    children: [
      { title: 'Clients', roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'SalesPerson', 'TeamLeader'], path: '/clients' },
      { title: 'Campaign', roles: ['Admin', 'CEO', 'Manager', 'OnlineSales', 'SalesPerson', 'TeamLeader'], path: '/campaign' },
    ],
  },
]


export default menuItems
